import { z } from 'zod'
import { baseSchema } from './base'

export const viewportSchema = baseSchema.extend({
  type: z.literal('viewport'),
  body: z.any().array().optional().describe('视窗内容'),
  data: z.record(z.string(), z.any()).optional().describe('视窗数据'),
})

export type ViewportSchema = z.infer<typeof viewportSchema>
